import React, { useEffect, useState } from 'react'
import { useSelector } from "react-redux";
import { Row, Col } from "react-bootstrap"
import '../../../styles/css/Card.css';
import BookBox from '../../../components/Products/sBook/V3/BookBox/index.js';
import MessageBox from '../../../components/Products/sBook/V3/MessageBox/index.js';
import MessageTree from '../../../components/Products/sBook/V3/MessageTree/index.js';
import MessageEventBox from '../../../components/Products/sBook/V3/MessageEventsBox'
import { useGetMessageBookMemberRelationshipProps } from '../../../hooks/services/sBook/useOfUser'
import { useGetMessageTreeByObjectByParty, useOnFilterMessages } from '../../../hooks/services/sBook/useOfMessage'
import FieldglassIntegration from '../../../components/Products/sBook/V3/FieldglassIntegration/index.js';
import { useHistory } from "react-router-dom";
import { useGetRelatedConceptReference } from '../../../hooks/services/sBook/useOfRelatedConcept.js';
import { __OBJECT_STRUCTURE_GetUserProps } from '../../../common/ObjectStructures/sBook';
import AuthVerify from '../../../components/Templates/Site/AuthVerify';

function Book(props) {

    //Objetos helpers requeridos.
    const history = useHistory();

    const { token: currentAuth } = useSelector((state) => state.auth);
    const aux_userName = currentAuth !== null ? currentAuth.token.userName.split('\\')[1] : null;

    const [userName, setUserName] = useState(null)
    const [fireGetMessage, setFireGetMessage] = useState(false);

    useEffect(()=> {
        const set = async () => {
            setUserName(aux_userName);
        }
        
        if (aux_userName !== null && aux_userName !== undefined && userName === null) {
            set();
        }
    }, [aux_userName, userName]);
    
    const [fireUpdateBoxListMessageEventControl, setFireUpdateBoxListMessageEventControl] = useState(false)

    //Constantes normales
    const queryStringBookId = props.match.params.bookId !== null && props.match.params.bookId !== undefined && props.match.params.bookId !== "" ?
    props.match.params.bookId : null;
    const queryStringMessageId = props.match.params.messageId !== null && props.match.params.messageId !== undefined && props.match.params.messageId !== "" ?
    props.match.params.messageId : null;

    //Constantes state.
    const [auxBookObject, setAuxBookObject] = useState({
        bookCode: "",
        bookNemo: null,
        id: queryStringBookId !== null ? parseInt(queryStringBookId) : null,
        name: "",
        requiresApproval: false,
        statusId: 0,
        messageCounts: null
    });

    //Podiras obtener desde qs el id del mensaje.
    //Luego en useOf podrias enviar el id, si es null, se asume que debe busccar el ultimo mensaje.
    //Si no es null quiere decir que viene un mensaje desde QS.

    const [bookRelatedConceptItem, setRelatedConceptItem] = useState(null);
    useGetRelatedConceptReference(auxBookObject, bookRelatedConceptItem, setRelatedConceptItem, false)

    const [auxMessageObject, setAuxMessageObject] = useState(null);

    const [userProps, setUserPropsObject] = useState(__OBJECT_STRUCTURE_GetUserProps());
    
    useGetMessageBookMemberRelationshipProps(auxBookObject.id, userName, userProps, setUserPropsObject);


    const [selectedItem, setSelectedItem] = useState(null);
    const [filterMessageText, setFilterMessageText] = useState("");
    const [forceFilterMessages, setForceFilterMessages] = useState(false);
    const [dataFilled, setDataFilled] = useState(false);
    

    const [selectedMessageId, setSelectedMessageId] = useState(null);

    const [objMessageListBase, setObjMessageListBase] = useState(null);
    const [objMessageList, setObjMessageList] = useState(null);
    const [objSectionList, setObjSectionList] = useState(null);
    const [messageTreeTypeGrid, setMessageTreeTypeGrid] = useState({fireUpdate: true, data: null, pageNumber: 1, pageSize: 10, filters: []});
    useGetMessageTreeByObjectByParty(
        auxBookObject.id,
        userProps && userProps.partyId,
        userProps && userProps.partyMemberId,
        objMessageList,
        setObjMessageList,
        setAuxMessageObject,
        queryStringMessageId,
        auxMessageObject !== null ? auxMessageObject.id : null,
        setSelectedMessageId,
        setMessageTreeTypeGrid,
        setObjSectionList,
        setObjMessageListBase
    )

    useOnFilterMessages(objMessageListBase, filterMessageText, forceFilterMessages, setForceFilterMessages, setObjMessageList, setAuxMessageObject, setSelectedMessageId, setMessageTreeTypeGrid, setObjSectionList)
    
   
    //Eventos de componente.
    const setFireUpdateBoxListMessageEvent = () => {
        setFireUpdateBoxListMessageEventControl(true);
    }

    useEffect(()=> {
        const redirectOut = async () => {
            console.log()
            if ((userProps.hasAccess === false && userProps.onlyObserver === false) || (userProps.statusId === 1 || userProps.statusId === 4)) {
                console.log()
                history.push({
                    pathname: '/',
                })
            }
        }
        
        if (userProps.username !== null && userProps.statusId !== 0) {
            redirectOut()
        }
    }, [userProps, auxBookObject, history]);

    //Toolbars.
    return (
        <>
            <AuthVerify currentToken={currentAuth} />
            <Row>
                <Col lg={12} xl={5} className='pb-2 ps-2 pe-1'>
                    <MessageTree
                        editMode={ auxBookObject.statusId !== 2 ? false : true }
                        bookObject={ auxBookObject }
                        userProps={ userProps }
                        userName={ userName }
                        objMessageList={objMessageList}
                        objMessageListGridType={messageTreeTypeGrid}
                        setterObjMessageListGridType={setMessageTreeTypeGrid}
                        setterObjMessageList={setObjMessageList}
                        setterMessageObject={ setAuxMessageObject }
                        selectedMessageId={ selectedMessageId }
                        setterSelectedMessageId={ setSelectedMessageId }
                        sectionList={objSectionList}
                        setterSelectedSectionStatusItem={setSelectedItem}
                        selectedSectionStatusItem={selectedItem}
                        objMessageSelected={auxMessageObject}
                        setterSelectedItem={setSelectedItem}
                        selectedItem={selectedItem}
                        setFireGetMessage={ setFireGetMessage }
                        filterMessageText={filterMessageText}
                        setFilterMessageText={setFilterMessageText}
                        forceFilterMessages={forceFilterMessages}
                        setForceFilterMessages={setForceFilterMessages}
                        messageCounts={auxBookObject.messageCounts}
                        setDataFilled={setDataFilled}
                    />
                </Col>
                <Col lg={12} xl={4} className='pb-2 px-1'>
                    <MessageBox
                        bookObject={ auxBookObject }
                        userProps={ userProps }
                        messageObjectId={ auxMessageObject !== null ? auxMessageObject.id : null }
                        messageObjectSectionId={  auxMessageObject !== null ? auxMessageObject.sectionId : null }
                        messageObjectStatusId={  auxMessageObject !== null ? auxMessageObject.statusId : null }
                        setterFireUpdateBoxListControl={ setFireUpdateBoxListMessageEvent }
                        editMode={ true }
                        currentUserName={userName}
                        setterObjMessageList={ setObjMessageList }
                        fireGetMessage={fireGetMessage}
                        setFireGetMessage={ setFireGetMessage }
                        messageCounts={auxBookObject.messageCounts}
                        dataFilled={dataFilled}
                        setDataFilled={setDataFilled}
                    />
                </Col>
                <Col lg={12} xl={3} className='ps-1 pe-2'>
                    <div className='pb-2 h-34'>
                        <BookBox
                            relatedConceptItem={bookRelatedConceptItem}
                            editMode={ false }
                            showImpersonation={ currentAuth && currentAuth.token.profile[0] === "sAdmin" }
                            queryStringBookId={ queryStringBookId }
                            setterBookObject={ setAuxBookObject }
                            showNumber={false}
                            showSwitchLayout={true}
                            setterUserPropsObject={setUserPropsObject}
                            setterObjMessageList={setObjMessageList}
                            setterUserName={setUserName}
                            userProps={userProps}
                            objMessageList={objMessageList}
                        />
                    </div>
                    <div className='pb-2 h-40'>
                        <FieldglassIntegration fieldglassMode={false} bookObject={ auxBookObject } bookRelatedConceptItem={bookRelatedConceptItem} />
                    </div>
                    <div className='pb-2 h-26'>
                        <MessageEventBox
                            bookObject={ auxBookObject }
                            messageObject={ auxMessageObject }
                            fireUpdateBoxListMessageEventControl={ fireUpdateBoxListMessageEventControl }
                            settetFireUpdateBoxListMessageEventControl={setFireUpdateBoxListMessageEventControl}
                            userProps={userProps}
                            messageCounts={auxBookObject.messageCounts}
                        />
                    </div>
                </Col>
            </Row>
        </>
    ); 
}

export default Book;